import React, { Component } from 'react';
import { GraingerAccountContext } from '../Context/Context';

import Pages from '../Context/Pages';

import getPage from './Router';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: Pages.Home,
      setPage: this.setPage.bind(this),
    };
  }

  setPage(page) {
    window.location.href = page;
  }

  render() {
    return (
      <GraingerAccountContext.Provider value={this.state}>
        <Header />
        <div className='App'>
          {getPage()}
        </div>
        <Footer />
      </GraingerAccountContext.Provider>
    );
  }
}

export default App;